import { CSSProperties, useEffect, useState } from "react";
import { TranslationService } from "../../../services/TranslationService";

const SearchInput = ({
  onSearch,
  style,
  autosearch = true,
  placeholder = undefined,
  divClass = "",
  defaultValue = ""
}: {
  onSearch: (value: string) => void;
  style?: CSSProperties;
  autosearch?: boolean;
  placeholder?: string;
  divClass?: string;
  defaultValue?: string;
}) => {
  const [searchTerm, setSearchTerm] = useState(defaultValue);

  useEffect(() => {
    setSearchTerm(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    // Inyectar el estilo del placeholder una sola vez
    const styleId = "search-input-placeholder-style";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
                .search-input-text::placeholder {
                    color: #333232;
                    opacity: 1;
                }
            `;
      document.head.appendChild(style);
    }
  }, []);

  const search = (value?: string) => {
    onSearch(value ?? searchTerm);
  };
  const onChange = (value: string) => {
    setSearchTerm(value);
    if (autosearch) {
      search(value);
    }
  };
  const inputStyle: CSSProperties = {
    color: "#333232",
    ...style
  };

  return (
    <div className={"search-input input-group " + divClass}>
      <button
        className="btn btn-outline-secondary"
        type="button"
        onClick={() => search()}
      >
        <i className="far fa-search"></i>
      </button>
      <input
        type="text"
        style={inputStyle}
        className="form-control search-input-text"
        placeholder={placeholder ?? TranslationService.translate.ApplySearch}
        value={searchTerm}
        onKeyPress={(event) => event.key === "Enter" && search()}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default SearchInput;
